import { addErrorLogger } from "./modules/onerror";
import { defaultListeners, addCollapsibleListeners } from "./modules/collapse";

addErrorLogger();

document.addEventListener("DOMContentLoaded", () => {
  addMenuListeners();
  defaultListeners(
    function(collapsible, toggle) {
      toggle.classList.add("rotate-180");
    },
    function(collapsible, toggle) {
      toggle.classList.remove("rotate-180");
    }
  );

  document.querySelectorAll('[id^="bereiding-"]').forEach((collapsible) => {
    addCollapsibleListeners(
      collapsible,
      function() {},
      function() {}
    );
  });
});

function addMenuListeners() {
  // Menu interactions
  document.querySelectorAll("#menu-menu a,#menu-menu-1 a ").forEach((menuButton) => {
    menuButton.addEventListener("click", (e) => {
      e.preventDefault();

      var element = document.getElementById(menuButton.href.split("#")[1]);

      var top = getOffsetTop(element);

      closeMenu();

      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: top,
      });
    });
  });

  // const logo = document.getElementById("logo");
  // window.addEventListener("scroll", () => {
  //   toggleLogo(logo);
  // });
  // toggleLogo(logo);

  const menuToggle = document.getElementById("menu-toggle");

  menuToggle.addEventListener("click", () => {
    toggleMenu();
  });
}

function toggleMenu() {
  const mobileMenu = document.getElementById("mobile-menu");
  const menuToggle = document.getElementById("menu-toggle");

  if (mobileMenu.classList.toggle("-translate-y-full")) {
    menuToggle.children[0].classList.remove("opacity-0");
    menuToggle.children[1].classList.add("opacity-0");
  } else {
    menuToggle.children[0].classList.add("opacity-0");
    menuToggle.children[1].classList.remove("opacity-0");
  }
}

function closeMenu() {
  const mobileMenu = document.getElementById("mobile-menu");
  const menuToggle = document.getElementById("menu-toggle");

  mobileMenu.classList.add("-translate-y-full");
  menuToggle.children[0].classList.remove("opacity-0");
  menuToggle.children[1].classList.add("opacity-0");
}

function toggleLogo(logo) {
  if (window.scrollY > 100) {
    logo.classList.add("scale-50");
  } else {
    logo.classList.remove("scale-50");
  }
}

const getOffsetTop = (element) => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
};
